/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './cookie-consent.component';
import * as import1 from '@angular/core/src/change_detection/change_detection';
import * as import2 from '@angular/core/src/linker/view_utils';
import * as import3 from '@angular/core/src/linker/view';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/linker/element';
import * as import6 from '@angular/core/src/di/injector';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '../shared/intl.service';
import * as import9 from '../shared/config.service';
import * as import10 from '../shared/utils.service';
import * as import11 from 'angular2-cookie/services/cookies.service';
import * as import12 from '@angular/core/src/linker/element_ref';
import * as import13 from '@angular/core/src/metadata/view';
import * as import14 from '@angular/core/src/linker/component_factory';
import * as import15 from '../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import16 from '../shared/intl.pipe';
import * as import17 from '@angular/core/src/linker/template_ref';
import * as import18 from '@angular/common/src/directives/ng_if';
import * as import19 from '@angular/core/src/security';
export class Wrapper_CookieConsentComponent {
  context:import0.CookieConsentComponent;
  changed:boolean;
  /*private*/ _expr_0:any;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any) {
    this.changed = false;
    this.context = new import0.CookieConsentComponent(p0,p1,p2,p3,p4,p5);
    this._expr_0 = import1.UNINITIALIZED;
  }
  check_language(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this.changed = true;
      this.context.language = currValue;
      this._expr_0 = currValue;
    }
  }
  detectChangesInInputProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_CookieConsentComponent_Host:import4.RenderComponentType = (null as any);
class _View_CookieConsentComponent_Host0 extends import3.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import5.AppElement;
  _CookieConsentComponent_0_4:Wrapper_CookieConsentComponent;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_CookieConsentComponent_Host0,renderType_CookieConsentComponent_Host,import7.ViewType.HOST,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer,'policy-checker',import2.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import5.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_CookieConsentComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._CookieConsentComponent_0_4 = new Wrapper_CookieConsentComponent(this.parentInjector.get(import8.IntlService),this.parentInjector.get(import9.ConfigService),this.parentInjector.get(import10.UtilsService),this.parentInjector.get(import11.CookieService),this.renderer,new import12.ElementRef(this._el_0));
    this._appEl_0.initComponent(this._CookieConsentComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._CookieConsentComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.CookieConsentComponent) && (0 === requestNodeIndex))) { return this._CookieConsentComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._CookieConsentComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._CookieConsentComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._CookieConsentComponent_0_4.context.ngAfterViewInit(); } }
  }
}
function viewFactory_CookieConsentComponent_Host0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  if ((renderType_CookieConsentComponent_Host === (null as any))) { (renderType_CookieConsentComponent_Host = viewUtils.createRenderComponentType('',0,import13.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_CookieConsentComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const CookieConsentComponentNgFactory:import14.ComponentFactory<import0.CookieConsentComponent> = new import14.ComponentFactory<import0.CookieConsentComponent>('policy-checker',viewFactory_CookieConsentComponent_Host0,import0.CookieConsentComponent);
const styles_CookieConsentComponent:any[] = ([] as any[]);
var renderType_CookieConsentComponent:import4.RenderComponentType = (null as any);
class _View_CookieConsentComponent0 extends import3.AppView<import0.CookieConsentComponent> {
  _anchor_0:any;
  /*private*/ _appEl_0:import5.AppElement;
  _TemplateRef_0_5:any;
  _NgIf_0_6:import15.Wrapper_NgIf;
  _pipe_intl_0:import16.IntlPipe;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_CookieConsentComponent0,renderType_CookieConsentComponent,import7.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._anchor_0 = this.renderer.createTemplateAnchor(parentRenderNode,(null as any));
    this._appEl_0 = new import5.AppElement(0,(null as any),this,this._anchor_0);
    this._TemplateRef_0_5 = new import17.TemplateRef_(this._appEl_0,viewFactory_CookieConsentComponent1);
    this._NgIf_0_6 = new import15.Wrapper_NgIf(this._appEl_0.vcRef,this._TemplateRef_0_5);
    this._pipe_intl_0 = new import16.IntlPipe();
    this.init(([] as any[]),[this._anchor_0],([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import17.TemplateRef) && (0 === requestNodeIndex))) { return this._TemplateRef_0_5; }
    if (((token === import18.NgIf) && (0 === requestNodeIndex))) { return this._NgIf_0_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:boolean = !this.context.hasConsented;
    this._NgIf_0_6.check_ngIf(currVal_0_0_0,throwOnChange,false);
    this._NgIf_0_6.detectChangesInInputProps(this,this._anchor_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
export function viewFactory_CookieConsentComponent0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<import0.CookieConsentComponent> {
  if ((renderType_CookieConsentComponent === (null as any))) { (renderType_CookieConsentComponent = viewUtils.createRenderComponentType('',0,import13.ViewEncapsulation.None,styles_CookieConsentComponent,{})); }
  return new _View_CookieConsentComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_CookieConsentComponent1 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _el_5:any;
  _text_6:any;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _text_19:any;
  _text_20:any;
  /*private*/ _expr_21:any;
  _pipe_intl_0_0:any;
  /*private*/ _expr_23:any;
  /*private*/ _expr_24:any;
  _pipe_intl_0_1:any;
  /*private*/ _expr_26:any;
  _pipe_intl_0_2:any;
  /*private*/ _expr_28:any;
  _pipe_intl_0_3:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_CookieConsentComponent1,renderType_CookieConsentComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_21 = import1.UNINITIALIZED;
    this._expr_23 = import1.UNINITIALIZED;
    this._expr_24 = import1.UNINITIALIZED;
    this._expr_26 = import1.UNINITIALIZED;
    this._expr_28 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'div',new import2.InlineArray4(4,'class','cookie-consent pop-up-content white-popup-block mfp-hide col-lg-10 col-xs-11 center-col bg-white text-center modal-popup-main','id','cookie-consent'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,this._el_0,'h4',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._el_4 = import2.createRenderElement(this.renderer,this._el_2,'small',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._el_5 = import2.createRenderElement(this.renderer,this._el_4,'a',new import2.InlineArray2(2,'target','_blank'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'',(null as any));
    this._text_7 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_8 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_9 = import2.createRenderElement(this.renderer,this._el_0,'div',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'\n        ',(null as any));
    this._el_11 = import2.createRenderElement(this.renderer,this._el_9,'a',new import2.InlineArray2(2,'class','pointer btn button'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'\n            ',(null as any));
    this._el_13 = import2.createRenderElement(this.renderer,this._el_11,'small',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'',(null as any));
    this._text_15 = this.renderer.createText(this._el_11,'\n        ',(null as any));
    this._text_16 = this.renderer.createText(this._el_9,' \n        ',(null as any));
    this._el_17 = import2.createRenderElement(this.renderer,this._el_9,'a',new import2.InlineArray2(2,'class','pointer highlight-button btn'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'',(null as any));
    this._text_19 = this.renderer.createText(this._el_9,'\n    ',(null as any));
    this._text_20 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._pipe_intl_0_0 = import2.pureProxy2((<_View_CookieConsentComponent0>this.parent)._pipe_intl_0.transform.bind((<_View_CookieConsentComponent0>this.parent)._pipe_intl_0));
    this._pipe_intl_0_1 = import2.pureProxy2((<_View_CookieConsentComponent0>this.parent)._pipe_intl_0.transform.bind((<_View_CookieConsentComponent0>this.parent)._pipe_intl_0));
    var disposable_0:Function = this.renderer.listen(this._el_11,'click',this.eventHandler(this._handle_click_11_0.bind(this)));
    this._pipe_intl_0_2 = import2.pureProxy2((<_View_CookieConsentComponent0>this.parent)._pipe_intl_0.transform.bind((<_View_CookieConsentComponent0>this.parent)._pipe_intl_0));
    var disposable_1:Function = this.renderer.listen(this._el_17,'click',this.eventHandler(this._handle_click_17_0.bind(this)));
    this._pipe_intl_0_3 = import2.pureProxy2((<_View_CookieConsentComponent0>this.parent)._pipe_intl_0.transform.bind((<_View_CookieConsentComponent0>this.parent)._pipe_intl_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._el_5,
      this._text_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._text_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._text_19,
      this._text_20
    ]
    ,[
      disposable_0,
      disposable_1
    ]
    ,([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_21:any = import2.interpolate(1,'\n        ',valUnwrapper.unwrap(import2.castByValue(this._pipe_intl_0_0,(<_View_CookieConsentComponent0>this.parent)._pipe_intl_0.transform)(((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.COMMON.COOKIE_CONSENT),this.parent.context.language)),'\n        ');
    if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange,this._expr_21,currVal_21))) {
      this.renderer.setText(this._text_3,currVal_21);
      this._expr_21 = currVal_21;
    }
    const currVal_23:any = import2.interpolate(1,'',((this.parent.context.language == 'en')? 'http://ec.europa.eu/ipg/basics/legal/cookies/index_en.htm': 'https://www.cnil.fr/fr/site-web-cookies-et-autres-traceurs'),'');
    if (import2.checkBinding(throwOnChange,this._expr_23,currVal_23)) {
      this.renderer.setElementProperty(this._el_5,'href',this.viewUtils.sanitizer.sanitize(import19.SecurityContext.URL,currVal_23));
      this._expr_23 = currVal_23;
    }
    valUnwrapper.reset();
    const currVal_24:any = import2.interpolate(1,'',valUnwrapper.unwrap(import2.castByValue(this._pipe_intl_0_1,(<_View_CookieConsentComponent0>this.parent)._pipe_intl_0.transform)(((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.COMMON.LEARN_MORE),this.parent.context.language)),'');
    if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange,this._expr_24,currVal_24))) {
      this.renderer.setText(this._text_6,currVal_24);
      this._expr_24 = currVal_24;
    }
    valUnwrapper.reset();
    const currVal_26:any = import2.interpolate(1,'',valUnwrapper.unwrap(import2.castByValue(this._pipe_intl_0_2,(<_View_CookieConsentComponent0>this.parent)._pipe_intl_0.transform)(((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.COMMON.COOKIE_CONSENT_DISMISS),this.parent.context.language)),'');
    if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange,this._expr_26,currVal_26))) {
      this.renderer.setText(this._text_14,currVal_26);
      this._expr_26 = currVal_26;
    }
    valUnwrapper.reset();
    const currVal_28:any = import2.interpolate(1,'\n            ',valUnwrapper.unwrap(import2.castByValue(this._pipe_intl_0_3,(<_View_CookieConsentComponent0>this.parent)._pipe_intl_0.transform)(((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.COMMON.COOKIE_CONSENT_ACCEPT),this.parent.context.language)),' \n        ');
    if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange,this._expr_28,currVal_28))) {
      this.renderer.setText(this._text_18,currVal_28);
      this._expr_28 = currVal_28;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_11_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_11_0:any = ((<any>this.parent.context.onConsent(false)) !== false);
    return (true && pd_11_0);
  }
  private _handle_click_17_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_17_0:any = ((<any>this.parent.context.onConsent(true)) !== false);
    return (true && pd_17_0);
  }
}
function viewFactory_CookieConsentComponent1(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_CookieConsentComponent1(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/cookie-consent.component.ngfactory.ts